/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AfterViewInit, Directive, ElementRef, Inject, OnDestroy} from '@angular/core';

import {FullScreenPreviewContainment} from '../../base/nude/creative-preview-runner';
import {WINDOW} from '../../angular-platform-providers';

@Directive({
  standalone: true,
  selector: '[adnContainFullScreenPreview]'
})
export class ContainFullScreenPreviewDirective implements AfterViewInit, OnDestroy {
  private containment: FullScreenPreviewContainment;

  constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    @Inject(WINDOW) private readonly window: any
  ) {
  }

  ngAfterViewInit(): void {
    this.containment = new FullScreenPreviewContainment(this.window, this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.containment?.disconnect();
  }
}
